export const iconFontAwesomeEditingSignature = (
	<i className="fa-solid fa-signature"></i>
);
